import { lazyPage } from "./lazy-page";

export const pages = {
	login: lazyPage(() => import("@/pages/auth/login-page"), "LoginPage"),
	signup: lazyPage(() => import("@/pages/auth/signup-page"), "SignupPage"),
	projects: lazyPage(() => import("@/pages/projects/projects-page"), "ProjectsPage"),
	overview: lazyPage(() => import("@/pages/overview/overview-page"), "OverviewPage"),
	content: lazyPage(() => import("@/pages/content/content-page"), "ContentPage"),
	contentDetail: lazyPage(() => import("@/pages/content/content-detail-page"), "ContentDetailPage"),
	inbox: lazyPage(() => import("@/pages/inbox/inbox-page"), "InboxPage"),
	plan: lazyPage(() => import("@/pages/plan/plan-page"), "PlanPage"),
	agents: lazyPage(() => import("@/pages/agents/agents-page"), "AgentsPage"),
	agentDetail: lazyPage(() => import("@/pages/agents/agent-detail-page"), "AgentDetailPage"),
	flows: lazyPage(() => import("@/pages/flows/flows-page"), "FlowsPage"),
	flowCanvas: lazyPage(() => import("@/pages/flows/flow-canvas-page"), "FlowCanvasPage"),
	artifacts: lazyPage(() => import("@/pages/artifacts/artifacts-page"), "ArtifactsPage"),
	calendar: lazyPage(() => import("@/pages/calendar/calendar-page"), "CalendarPage"),
	strategy: lazyPage(() => import("@/pages/strategy/strategy-page"), "StrategyPage"),
	analytics: lazyPage(() => import("@/pages/analytics/analytics-page"), "AnalyticsPage"),
	competitors: lazyPage(() => import("@/pages/competitors/competitors-page"), "CompetitorsPage"),
	ads: lazyPage(() => import("@/pages/ads/ads-page"), "AdsPage"),
	assistant: lazyPage(() => import("@/pages/assistant/assistant-page"), "AssistantPage"),
	projectSettings: lazyPage(
		() => import("@/pages/projects/project-settings-page"),
		"ProjectSettingsPage",
	),
	accountSettings: lazyPage(
		() => import("@/pages/settings/account-settings-page"),
		"AccountSettingsPage",
	),
	workspaceSettings: lazyPage(
		() => import("@/pages/settings/workspace-settings-page"),
		"WorkspaceSettingsPage",
	),
	members: lazyPage(() => import("@/pages/settings/members-page"), "MembersPage"),
	roles: lazyPage(() => import("@/pages/settings/roles-page"), "RolesPage"),
	billing: lazyPage(() => import("@/pages/settings/billing-page"), "BillingPage"),
	invite: lazyPage(() => import("@/pages/invite/invite-page"), "InvitePage"),
	notFound: lazyPage(() => import("@/pages/not-found-page"), "NotFoundPage"),
};
